import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'
import { URL_SERVICIOS_LOCALES, URL_SERVICIOS_AWS } from '../../config/url.servicio'

@Injectable()
export class TiposReservasProvider {
  token:string

  constructor(public http: Http, private storage: Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
    });
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=tiposReservas`)
    .map((data) => data.json())
  }
  buscarTiposReservasCompaniasId(valor:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarTiposReservas",
        parameters : {companiasId: valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  guardar(tiposReserva: any) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {
                      ...tiposReserva
                    }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  actualizar(tiposReservas: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: tiposReservas.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "A",
          nombreTabla: "tiposReservas",
          ...tiposReservas
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  eliminar(tiposReservas: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: tiposReservas.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          tiposReservasId : tiposReservas.tiposReservasId,
          nombreTabla: "tiposReservas"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  buscarEstadosParqueaderoCompaniasId(valor:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarEstadosParqueadero",
      parameters : {companiasId: valor}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}
}



// WEBPACK FOOTER //
// ./src/providers/tiposReservas/tiposReservas.ts